<script>
import { Modal } from 'bootstrap';
import { onMount } from 'svelte';

function onDelete(id) {
  var myModal = new Modal(document.getElementById('exampleModal'), {})
  myModal.show()
}

let resolver = null;
let modal;
let modalTitle = '';
let modalText = '';
let actionText = '';

window.confirmDelete = (title, text = '') => {
  modalTitle = title;
  modalText = text;
  actionText = 'Dzēst';
  modal.show();

  return new Promise(resolve => {
    resolver = resolve;
  });
}

window.confirmAction = (title, text = '', action = 'Jā') => {
  modalTitle = title;
  modalText = text;
  actionText = action;
  modal.show();

  return new Promise(resolve => {
    resolver = resolve;
  });
}

function onClick() {
  modal.hide();
  modalTitle = '';
  modalText = '';
  actionText = '';
  resolver(true);
}

onMount(() => {
  modal = new Modal(document.getElementById('confirmModal'), {})
});
</script>

<div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{modalTitle}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      {#if modalText}
        <div class="modal-body">
          {modalText}
        </div>
      {/if}
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Atcelt</button>
        <button on:click={onClick} type="button" class="btn btn-danger">{actionText}</button>
      </div>
    </div>
  </div>
</div>
